import { reportError } from './sentry';

export const leaveMeeting = (meeting) => {
  meeting.leave().catch(reportError);
};
